import styled from "styled-components";

export const StyledLinearBox = styled.div`
	color: #837f7f;
	padding-bottom: 15px;
	z-index: 15;

	& > p {
		width: 100%;
		height: 7px;
		z-index: 1000;
	}
`;
